import { isValidIBAN } from 'ibantools';
import * as yup from 'yup';

import type { SummaryPaymentDetailsTextualData } from './summary-step.types';

/** IBAN field shape for yup schemas — spread into `yup.object({ ... })`. */
export const getIbanSchemaFields = (
  isPersonalDetailsEditProhibited: boolean | undefined,
  paymentDetails?: SummaryPaymentDetailsTextualData,
): yup.ObjectShape => {
  if (isPersonalDetailsEditProhibited) {
    return {};
  }

  return {
    iban: yup
      .string()
      .required(paymentDetails?.ibanFormField?.value?.requiredMessage)
      .test(
        'iban validation',
        paymentDetails?.ibanFormField?.value?.validationMessage ?? '',
        iban => !!(iban && isValidIBAN(iban.replace(/\s+/g, '').toUpperCase())),
      ),
  };
};

export const createIbanFormSchema = (
  isPersonalDetailsEditProhibited: boolean | undefined,
  paymentDetails?: SummaryPaymentDetailsTextualData,
) => yup.object(getIbanSchemaFields(isPersonalDetailsEditProhibited, paymentDetails));
